import { EssHeader } from '@/components/ess/EssHeader';
import { NavPage } from '@/components/page/Breadcrumbs';
import { FC } from 'react';
import { FiBell } from 'react-icons/fi';
import strings from '../ess.translations';

export const MyRequestsHeader: FC = () => {
  const breadcrumbs: NavPage[] = [
    {
      name: strings.myRequests.header,
      to: `/ess/requests`
    }
  ];

  return <EssHeader title={strings.myRequests.header} icon={FiBell} breadcrumbs={breadcrumbs} />;
};
